import ClientScrollEffect from "./ClientScrollEffect";

const Clients = () => {
  return (
    <section className="clients-section" id="clients">
      <p className="clients-tag">OUR PARTNERS</p>

      <h2 className="clients-heading">Trusted by</h2>

      <ClientScrollEffect baseVelocity={2}>
        <img src={require("../assets/company-1.png")} className="client" alt="Company 1" />
        <img src={require("../assets/company-2.png")} className="client" alt="Company 2" />
        <img src={require("../assets/company-3.png")} className="client" alt="Company 3" />
      </ClientScrollEffect>

      <ClientScrollEffect baseVelocity={-2}>
        <img src={require("../assets/company-5.png")} className="client" alt="Company 5" />
        <img src={require("../assets/company-4.png")} className="client" alt="Company 4" />
      </ClientScrollEffect>
    </section>
  );
};

export default Clients;